import { useEffect, useState } from 'react';
import { useFetcher } from '../hooks/useFetcher';
import Carousel from './CustomCarousel';

const ProductRowFetcher = ({ products, rerender, callBack }) => {
  const [cart, setCart] = useState(null);

  const [data,, loading] = useFetcher(products);

  const isInArray = (source, item) => {
    const checkId = (obj) => obj.id === item.id;
    return source.some(checkId);
  };

  const addToCart = (item) => {
    let newData = [];
    const lsData = JSON.parse(localStorage.getItem('products'));

    if (lsData) {
      if (isInArray(lsData, item)) {
        newData = lsData.filter((product) => product.id !== item.id);
      } else {
        

        newData = [...lsData, item];
      }
    } else {
      newData = [item];
    }
    let counterss=0
    newData.map(()=>{
      counterss++;
    })
    document.querySelector(".cart-number").innerHTML=counterss;
    setCart(newData);
    callBack((prev) => !prev);
    localStorage.setItem('products', JSON.stringify(newData));
  };

  useEffect(() => {
    setCart(() => {
      return JSON.parse(localStorage.getItem('products'));
    });
  }, [products, rerender]);
  
  return (
    <div className="w-full p-5 px-10 m-auto">
      {data && <Carousel data={data.data} addToCart={addToCart} cart={cart} />}
    </div>
  );
};

export default ProductRowFetcher;
